/* eslint-disable prettier/prettier */
import { Button, Container, Row } from 'react-bootstrap'
import { makeData } from 'utils/makeData'
import referralCopyIcon from 'assets/images/profilepage-referralCopy.svg'
import arrowNextIcon from 'assets/images/arrow-next-white.svg'
import { useEffect, useRef, useState } from 'react'
import ConfirmModal from 'components/Modal/ConfirmModal'
import {
	HeaderAccountGifthistSVG,
	HeaderAccountInvitationSVG,
	HeaderAccountLogoutSVG,
	HeaderAccountMyaccountSVG,
	HeaderAccountSettingSVG,
	HeaderFriendSVG,
} from 'assets/svg/HeaderSVG'
import { ProfileIntroduceSVG } from 'assets/svg/HeaderSVG/ProfileIntroduceSVG'
import { Link, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { PATHS } from 'config/routes'
import modalSuccessIcon from 'assets/images/modal-success.svg'
import modalErrorIcon from 'assets/images/modal-error.svg'
import { useQuery, useQueryClient } from 'react-query'
import { getUserInfoQuery, useCheckSub } from 'dataLayer/game'
import avaDefault from 'assets/images/ava-default.jpeg'
import { destroyUser, removeModal } from 'utils/localStorage'
import { queryKeyUserInfo } from 'dataLayer/user'
import { CancelSVG } from 'assets/svg/ProfileSVG/CancelSVG'
import CancelProfileModal from 'components/Modal/CancelProfileModal'

function MenuMobile() {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const queryClient = useQueryClient()
	const [modalCancel, setModalCancel] = useState(false)
	const [dataCheckSub, setDataCheckSub] = useState()

	const invitation = makeData('invitation', 17)
	const { data: userInfo } = useQuery(getUserInfoQuery())

	const [showSuccess, setShowSuccess] = useState(false)
	const [showError, setShowError] = useState(false)
	const referralCodeRef = useRef(null)

	function openCancelModal() {
		setModalCancel(!modalCancel)
	}

	function handleCopyReferralCode() {
		const referralCode = referralCodeRef.current.innerText
		if (window.isSecureContext && navigator.clipboard) {
			navigator.clipboard.writeText(referralCode).then(
				() => {
					if (referralCode == null || referralCode === '') {
						referralErrorAlert()
					} else {
						referralSuccessAlert()
					}
				},
				() => {
					referralErrorAlert()
				},
			)
		} else {
			unsecuredCopyToClipboard(referralCode)
		}
	}
	function unsecuredCopyToClipboard(text) {
		const textArea = document.createElement('textarea')
		textArea.value = text
		document.body.appendChild(textArea)
		textArea.focus()
		textArea.select()
		try {
			document.execCommand('copy')
			referralSuccessAlert()
		} catch (err) {
			referralErrorAlert()
		}
		document.body.removeChild(textArea)
	}
	function referralSuccessAlert() {
		setShowError(false)
		setShowSuccess(true)
		setTimeout(() => {
			setShowSuccess(false)
			setShowError(false)
		}, 3000)
	}
	function referralErrorAlert() {
		setShowSuccess(false)
		setShowError(true)
		setTimeout(() => {
			setShowSuccess(false)
			setShowError(false)
		}, 3000)
	}

	const [modalConfirm, setModalConfirm] = useState(false)
	function openConfirmModal() {
		setModalConfirm(true)
	}
	function closeConfirmModal() {
		setModalConfirm(false)
	}

	function handleLogout() {
		destroyUser()
		removeModal()
		closeConfirmModal()
		queryClient.invalidateQueries(queryKeyUserInfo)
		navigate(PATHS.HOME_PAGE)
	}

	const { mutate } = useCheckSub(data => {
		if (data?.responseCode === '200') {
			setDataCheckSub(data?.data)
		}
	})

	useEffect(() => {
		mutate({ location: 'BEAT_MOUSE', from: '' })
	}, [])

	const handleYes = () => {
		window.location.href = dataCheckSub?.urlWebView ?? ''
	}


	return (
		<>
			<Container fluid className="profilepage-sidebar mobile p-3">
				<Row className="profilepage-sidebar__info rounded-0">
					<Row>
						<div className="ava-frame">
							<img
								src={userInfo?.avatarImage ?? avaDefault}
								onError={e => {
									e.target.onerror = null
									e.target.src = avaDefault
								}}
								alt="User's avatar"
							/>
						</div>
						<div>
							<p>{userInfo?.displayName}</p>
							<p>ID: {userInfo?.id}</p>
						</div>
					</Row>
					{/* <Row className="pe-0">
						<p ref={referralCodeRef} className="mt-2 mt-sm-3">
							{userInfo?.referralCode}
						</p>
						<img
							src={
								showSuccess
									? modalSuccessIcon
									: showError
										? modalErrorIcon
										: referralCopyIcon
							}
							onClick={handleCopyReferralCode}
							alt="Copy refferal code"
						/>
					</Row> */}
				</Row>
				<Row className="profilepage-sidebar__menu mobile mt-3 flex-column rounded-0">
					<Link to={PATHS.MY_ACCOUNT}>
						<div className="d-flex align-items-center">
							<HeaderAccountMyaccountSVG
								width="20"
								height="20"
								viewBox="0 0 19 19"
							/>
							{t('profile.sidebar.my_acc')}
						</div>
						<img src={arrowNextIcon} alt="" />
					</Link>
					{/* <Link to={PATHS.FRIEND_PAGE}>
						<div className="d-flex align-items-center">
							<HeaderFriendSVG width="20" height="20" viewBox="0 0 17 17" />
							{t('profile.sidebar.friend')}
						</div>
						<img src={arrowNextIcon} alt="" />
					</Link> */}
					<Link to={PATHS.GIFT_HIST}>
						<div className="d-flex align-items-center">
							<HeaderAccountGifthistSVG
								width="20"
								height="20"
								viewBox="0 0 19 19"
							/>
							{t('profile.sidebar.gift_hist')}
						</div>
						<img src={arrowNextIcon} alt="" />
					</Link>
					{/* <Link to={PATHS.INVITATION}>
						<div className="d-flex align-items-center">
							<HeaderAccountInvitationSVG
								width="20"
								height="20"
								viewBox="0 0 19 19"
							/>
							{t('profile.sidebar.invitation')}{' '} */}
					{/* {invitation.length < 10
								? `(0${invitation.length})`
								: `(${invitation.length})`} */}
					{/* </div>
						<img src={arrowNextIcon} alt="" />
					</Link> */}
					{/* <Link to={PATHS.INTRODUCE}>
						<div className="d-flex align-items-center">
							<ProfileIntroduceSVG width="20" height="20" viewBox="0 0 25 22" />
							{t('profile.sidebar.introduce')}
						</div>
						<img src={arrowNextIcon} alt="" />
					</Link> */}
					<Link to={PATHS.SETTING}>
						<div className="d-flex align-items-center">
							<HeaderAccountSettingSVG
								width="20"
								height="20"
								viewBox="0 0 19 19"
							/>
							{t('profile.sidebar.setting')}
						</div>
						<img src={arrowNextIcon} alt="" />
					</Link>
					{dataCheckSub?.isSub && (
						<Link to={'#'} onClick={openCancelModal} >
							<div className="d-flex align-items-center">
								<CancelSVG
									width="20"
									height="20" viewBox='0 0 24 24' />
								{t('profile.sidebar.cancel')}
							</div>
							<img src={arrowNextIcon} alt="" />
						</Link>
					)}

					<Button variant="dark" onClick={openConfirmModal}>
						<div className="d-flex align-items-center">
							{' '}
							<HeaderAccountLogoutSVG
								width="20"
								height="20"
								viewBox="0 0 19 19"
							/>
							{t('profile.sidebar.logout')}
						</div>
						<img src={arrowNextIcon} alt="" />
					</Button>
				</Row>
			</Container>
			<ConfirmModal
				show={modalConfirm}
				onHide={closeConfirmModal}
				title={t('modal.profile.logout')}
				onLogout={handleLogout}
			/>

			<CancelProfileModal
				show={modalCancel}
				onHide={openCancelModal}
				title={t('modal.profile.cancel')}
				onClick={handleYes}
			/>
		</>
	)
}

export default MenuMobile
